module.exports = __webpack_public_path__ + "static/media/home.8b0a909d.svg";